import Dialog from '@pelckmans/elementis/components/dialog';
import ListSkeleton from './ListSkeleton';
import TableSkeleton from './TableSkeleton';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  variant: 'list' | 'table';
  headerTitle: string;
  bodyText: ReactNode;
  cta?: ReactNode;
};

function EmptyState({ variant, headerTitle, bodyText, cta }: Props) {
  const { t } = useTranslation();
  return (
    <div className={classNames('empty-loading-state', `empty-loading-state--${variant}`)} data-testid="empty-state">
      {variant === 'list' && <ListSkeleton />}

      {variant === 'table' && <TableSkeleton />}
      <Dialog id="empty-state-dialog" size="sm" className="empty-state-dialog" aria-label={t('EMPTY_STATE.A11Y_LABEL')}>
        <Dialog.Header title={headerTitle} />
        <Dialog.Body>{bodyText}</Dialog.Body>
        {cta && <Dialog.Footer buttonGroupPropsRight={{ 'aria-label': undefined, role: undefined, children: cta }} />}
      </Dialog>
    </div>
  );
}

export default EmptyState;
